import React from 'react';

export const HomeSection1 = ({ images, img1, img2, t }) => {
  const renderTwoImages = () => {
    return (
      <div className="themes-home-section-1-images">
        {images.map((item, key) => {
          return (
            <div key={key} style={{ maxWidth: '34vw' }}>
              <img src={item.icon} />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      {/* <div>{renderTwoImages()}</div> */}
      <div className="home-section-container margin-T90 margin-B50">
        <div className="pullman-section-primary-row">
          <div className="pullman-section-primary-row-main-heading black-text">
            {t('HOME.LEARN_ABOUT_OUR_PETS_ON_BOARD_DESTINATIONS')}
          </div>
          <div className="pullman-section-primary-row-underline "></div>
        </div>
        <div className="home-section-images-container">
          <div className="base-img-container">
            <div className="img-1-container">
              <img src={img1} alt="img1" />
            </div>
            <div className="img-2-container">
              <img src={img2} alt="img2" />
            </div>
          </div>

          <div className="absolute-data-section">
            <div style={{ marginLeft: '34%', marginTop: '6%', width: 400 }}>
              <div style={styles.capsule}>{t('HOME.SANTIAGO_ONE_WAY_AND_ROUND_TRIP')}</div>
              <div style={styles.sectionText}>
                Algarrobo · El Quisco · El Tabo · Cartagena · San Antonio · Valparaíso · Viña del
                Mar · Quilpué · Villa Alemana · Limache · Olmué · San Felipe · Los Andes · La
                Calera.
              </div>
            </div>

            <div style={{ marginLeft: '44%', marginTop: '4%', width: 400 }}>
              <div style={styles.capsule}>
                {t('HOME.VALPARAÍSO_·_VIÑA_DEL_MAR_ONE_WAY_AND_ROUND_TRIP')}
              </div>
              <div style={styles.sectionText}> San Felipe · Los Andes </div>
            </div>

            <div style={{ marginLeft: '50%', marginTop: '4%', width: 400 }}>
              <div style={styles.sectionTextGrey}>{t('HOME.SOLD_EXCLUSIVELY_ON')}</div>
              <div style={styles.sectionTextWebsite}> www.pullmanbus.cl </div>
            </div>

            <div style={{ marginLeft: '48%', marginTop: '4%', width: 400 }}>
              <div style={styles.capsule}>
                {t('HOME.VALPARAÍSO_·_VIÑA_DEL_MAR_ONE_WAY_AND_ROUND_TRIP')}
              </div>
              <div style={styles.sectionTermsText}>
                {t('HOME.PETS_CARRY_SECTION')}
                {/* {' '} */}

                {/* *Solo transportomos perros y gatos de menor tamano{' '} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  marginTop50: {
    marginTop: 80,
  },
  capsule: {
    backgroundColor: '#003ba7',
    borderRadius: 25,
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: '11pt',
    display: 'inline',
    fontWeight: 'bold',
    color: '#fff',
  },
  sectionText: {
    margin: 30,
    lineHeight: 1.4,
    fontSize: '11pt',
    fontWeight: 'bold',
  },
  sectionTermsText: {
    marginTop: 20,
    fontSize: '10pt',
  },
  sectionTextWebsite: {
    fontWeight: 'bold',
    fontSize: '14pt',
    color: '#fa5e00',
    marginTop: 10,
  },
  sectionTextGrey: {
    fontSize: '16pt',
    color: '#464647',
    fontWeight: 'bold',
  },
};

export default HomeSection1;



// WEBPACK FOOTER //
// ./src/features/home/HomeSection1/HomeSection1.js